import { useState, useEffect, createContext, useContext, ReactNode } from 'react';
import { api } from './useApi';
import type { Team } from '@ns-b2b/shared';

interface TeamsContextType {
    teams: Team[];
    isLoading: boolean;
    refreshTeams: () => Promise<void>;
}

const TeamsContext = createContext<TeamsContextType>({
    teams: [],
    isLoading: true,
    refreshTeams: async () => { },
});

export function TeamsProvider({ children }: { children: ReactNode }) {
    const [teams, setTeams] = useState<Team[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const refreshTeams = async () => {
        setIsLoading(true);
        const { data } = await api<{ data: Team[] }>('/api/teams');
        if (data) {
            setTeams((data as unknown as { data: Team[] }).data || []);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        refreshTeams();
    }, []);

    return (
        <TeamsContext.Provider value={{ teams, isLoading, refreshTeams }}>
            {children}
        </TeamsContext.Provider>
    );
}

export function useTeams() {
    return useContext(TeamsContext);
}
